export const defaultSelectedDate = () => {
    let today = new Date();

    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Se agrega 1 al mes ya que en JavaScript los meses van de 0 a 11.
    let day = String(today.getDate()).padStart(2, '0');

    return  `${year}-${month}-${day}`;
};

export const defaultSelectedDateFrom = () => {

    const fechaAnt = new Date();

    // Obtener el mes y año actuales
    const mesActual = fechaAnt.getMonth();
    const anioActual = fechaAnt.getFullYear();

    // Calcular el nuevo mes y año
    let nuevoMes = mesActual - 6;
    let nuevoAnio = anioActual;

    // Manejar el cambio de año si el nuevo mes es menor a 0
    while (nuevoMes < 0) {
        nuevoMes += 12;
        nuevoAnio--;
    }

    // Establecer la nueva fecha con los meses restados
    fechaAnt.setMonth(nuevoMes);
    fechaAnt.setFullYear(nuevoAnio);
    fechaAnt.setDate(1);

    return fechaAnt;

};

function formatDateToYYYYMMDDHHMMSS(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default {
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    params: {
        year_month_from: defaultSelectedDate(),
        year_month_up: defaultSelectedDate(),
        branch_office_id: null,
        contact_id: null,
        state_check_id: null,
    },
    params_contacts: {
        only_active:true,
        filter: "",
        paginate: false
    },
    data: [],
    contacts: [],
    check_states: [],
    auxiliary_accounts: [],
    loading: {
        form: false
    },
    payload:{
        branchoffice_id: null,
        voucherType_id: null,
        num_doc: null,
        prefix: null,
        date: formatDateToYYYYMMDDHHMMSS (new Date()),
        contact_id: null,
        city_id: null,
        document_id: null,
        user_id: null,
        document_transaction: {
            id: null,
            account_id: null,
            affects_document_id: null,
            document_payment_id: null,
            observation: "Consignación cheques",
            contact_id: 0,
            no_doc: null,
            value: 0,
            base_value: 0,
            order: 1,
            projects_column_visible: 0,
            contact_column_visible: true,
            cost_center_column_visible: false,
            base_value_column_visible: false,
            manage_document: false,
            validation_no_doc: null,
            account_code: "",
            account_name: "",
            tax_id: null,
            payment_column_visible: false,
            manage_bank_document: false,
            commissionable_concept: false,
            debit_credit: null,
            id_document_transactions: null
        },
        document_transactions: [],
        total_debit: null,
        total_credit: null,
        modal_loading:false,
        update_document_payments_methods:[],
    },
    documentSaved: null,
    loading_modal:false,
    show_pdf :false,
    file_name :null,
    pending_consigned: true,
};



// WEBPACK FOOTER //
// ./src/modules/check-consignment/state.js